<template>
  <div class="display-tickets-wrapper">
    <div v-if="!items.length" class="skeleton-wrapper">
      <van-skeleton title :row="7" />
    </div>
    <div v-else>
      <div class="tabs-wrapper">
        <van-tabs
          v-model="active"
          @click="handleChangeActive"
          :ellipsis="false"
          title-active-color="#111"
          title-inactive-color="#999"
          line-height="2px"
        >
          <van-tab v-for="(item, index) of items" :key="item.id">
            <template #title>
              <p class="title">{{ item.name }}</p>
              <van-tag text-color="red" color="white" @click="handleShow" v-show="active === index">
                余票查询
              </van-tag>
            </template>
          </van-tab>
        </van-tabs>
      </div>

      <div class="tickets-wrapper">
        <display-ticket-item
          v-for="item of tickets"
          :key="item.id"
          :value="item"
          @purchase="handlePurchase"
        />
        <div class="surplus-wrapper">
          <display-ticket-surplus
            :reserve="items[active].reserve"
            v-show="show"
            @showChange="handleShowChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DisplayTicketItem from './DisplayTicketItem.vue';
import DisplayTicketSurplus from '@/components/DisplayTicketSurplus.vue';

export default {
  components: {
    DisplayTicketItem,
    DisplayTicketSurplus,
  },
  props: {
    items: [Array],
    defaultActive: [Number],
  },
  data() {
    return {
      active: 0,
      id: undefined,
      show: false,
      index: 0,
    };
  },
  computed: {
    ...mapGetters(['spotId']),
    tickets() {
      if (!this.spotId) {
        const category = this.items.find(item => item.id === this.active);
        return category ? category.children : [];
      }
      return this.items[this.active].tickets;
    },
  },
  created() {
    if (this.items.length) this.active = this.defaultActive;
  },
  watch: {
    defaultActive(newActive) {
      this.active = newActive;
    },
  },
  methods: {
    handlePurchase(id, ticketType) {
      this.$router.push({ name: 'ticket_detail', query: { id, ticketType } });
    },
    handleChangeActive() {
      if (this.index !== this.active) {
        this.$emit('change', this.items[this.active]);
        this.index = this.active;
        this.show = false;
      }
    },
    handleShow() {
      this.show = !this.show;
    },
    handleShowChange() {
      this.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
.display-tickets-wrapper {
  background: #fff;
  position: relative;
  .skeleton-wrapper {
    padding-top: 16px;
  }
  .tabs-wrapper {
    padding: 4px;
    /deep/ .van-tabs__nav {
      display: block;
      white-space: nowrap;
      text-align: center;
      .van-tab {
        display: inline-block;
        text-align: center;
        margin: 2px 10px;
        position: relative;
        font-size: 100%;
        .title {
          font-family: 'Microsoft YaHei';
          letter-spacing: 1px;
          font-weight: bold;
        }
        .van-tag {
          flex-direction: column;
          flex: 1;
          position: absolute;
          top: 110%;
          left: 0;
          right: 0;
        }
      }
    }
  }
  .surplus-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    margin: 0 3% 30%;
    z-index: 1;
  }
}
</style>
